import { observable, action } from 'mobx';

class AppStore {
    @observable isMobile = false;
    @observable pageTitle = '';

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    @action
    setMobile(isMobile) {
        this.isMobile = isMobile;
    }

    @action
    setPageTitle(title) {
        this.pageTitle = title;
    }
}

export default AppStore;


// WEBPACK FOOTER //
// ./src/store/app.js